/* eslint-disable lines-around-comment */
import _ from 'lodash';
import { DEFAULT_LOCALE, INTL_LOCALE_OVERRIDES } from './config';

/**
 * @param {(string|string[])} locales
 * @returns {boolean}
 */
function areIntlLocalesSupported(locales) {
  if (!locales || typeof Intl === 'undefined') {
    return false;
  }

  if (!_.isArray(locales)) {
    locales = [locales];
  }

  const intlConstructors = [
    Intl.Collator,
    Intl.DateTimeFormat,
    Intl.NumberFormat,
  ].filter(intlConstructor => intlConstructor);

  if (intlConstructors.length === 0) {
    return false;
  }

  return intlConstructors.every(intlConstructor => {
    const supportedLocales = intlConstructor.supportedLocalesOf(locales);
    return supportedLocales.length === locales.length;
  });
}

/**
 * Load Intl polyfill
 * @returns {Promise}
 */
export function loadIntlPolyfill() {
  return import(/* webpackChunkName: "intl" */
  /* webpackMode: "lazy" */
  'intl').then(function applyIntlPolyfill(IntlPolyfill) {
    if (global.Intl) {
      Intl.NumberFormat = IntlPolyfill.NumberFormat;
      Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
    } else {
      global.Intl = IntlPolyfill;
    }
    return IntlPolyfill;
  });
}

/**
 * Load Intl polyfill with locale data
 * @param locale
 * @returns {*}
 */
export function loadIntlPolyfillData(locale) {
  locale = INTL_LOCALE_OVERRIDES[locale] || locale || DEFAULT_LOCALE;

  if (areIntlLocalesSupported(locale)) {
    return Promise.resolve(true);
  }

  return loadIntlPolyfill().then(() => {
    if (locale === DEFAULT_LOCALE) {
      return Promise.resolve(true);
    }
    return import(/* webpackChunkName: "intl/[request]" */
    /* webpackMode: "lazy" */
    `intl/locale-data/jsonp/${locale}`);
  });
}
